module.exports = __webpack_public_path__ + "076d2d23a30f4692c9e6e34c61324860.png";